import { c as _c } from "react/compiler-runtime";
export function GallerySkeleton(t0) {
  const $ = _c(9);
  const {
    size: t1,
    groupByDate: t2
  } = t0;
  const size = t1 === undefined ? "lg" : t1;
  const groupByDate = t2 === undefined ? true : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      sm: "grid-cols-2",
      lg: "grid-cols-2 md:grid-cols-4"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const sizeClasses = t3;
  if (groupByDate) {
    let t4;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = Array.from({
        length: 2
      });
      $[1] = t4;
    } else {
      t4 = $[1];
    }
    let t5;
    if ($[2] !== size || $[3] !== t4) {
      const skeletonGroups = t4.map(_temp);
      t5 = <div className="space-y-4">{skeletonGroups.map((group, groupIndex_0) => <div key={groupIndex_0} className="space-y-2"><div className="border-b pb-1"><div className="h-4 w-32 animate-pulse rounded bg-muted" /></div><div className={`grid gap-2 ${sizeClasses[size]}`}>{group.items.map(_temp2)}</div></div>)}</div>;
      $[2] = size;
      $[3] = t4;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    return t5;
  }
  const t4 = `grid gap-2 ${sizeClasses[size]}`;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = Array.from({
      length: 8
    }).map(_temp3);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}
function _temp3(__1, index) {
  return <div key={index} className="aspect-square animate-pulse rounded-lg bg-muted" />;
}
function _temp2(__0, itemIndex) {
  return <div key={itemIndex} className="aspect-square animate-pulse rounded-lg bg-muted" />;
}
function _temp(_, groupIndex) {
  return {
    date: new Date(Date.now() - groupIndex * 86400000),
    items: Array.from({
      length: 8
    })
  };
}